import { render } from "./DetailStoreHeader.vue?vue&type=template&id=4b6ad16a&scoped=true"
import script from "./DetailStoreHeader.vue?vue&type=script&lang=js"
export * from "./DetailStoreHeader.vue?vue&type=script&lang=js"

import "./DetailStoreHeader.vue?vue&type=style&index=0&id=4b6ad16a&lang=scss&scoped=true"

import exportComponent from "/Users/opm/opm-vue-pc/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4b6ad16a"]])

export default __exports__